import { Bar, mixins } from "vue-chartjs"
import numeral from "numeral"

export default Bar.extend({
    mixins: [mixins.reactiveProp],
    mounted () {
        this.renderChart(this.chartData, this.options)
    },
    watch: {
        yMax: {
            handler (newOption, oldOption) {
                this._chart.destroy()
                this.renderChart(this.chartData, this.options)
            },
            deep: true
        }/*,
        'mode': {
            handler (newOption, oldOption) {
                this._chart.destroy()
                this.renderChart(this.chartData, this.options)
            },
            deep: true
        } */
    },
    methods: {
        click (event) {
            try {
                const chart_element = this._chart.getElementAtEvent(event)[0]
                const dataset = this._chart.config.data.datasets[chart_element._datasetIndex]
                this.$emit("click", dataset.project.id, event)
            } catch (e) {}
        }
    },
    computed: {
        options () {
            return {
                onClick: this.click,
                tooltips: {
                    displayColors: false,
                    callbacks: {
                        title: (tooltipItems, data) => {
                            let label = ""
                            const project = data.datasets[tooltipItems[0].datasetIndex].project
                            if(project) {
                                label = project.nickname || project.name
                                if(project.number) label = `${project.number} ${label}`
                            }
                            const lines = [label]
                            if(project && project.pic_initials) lines.push(`PIC: ${project.pic_initials}`)
                            if(project && project.pm_initials) lines.push(`PM: ${project.pm_initials}`)
                            return lines
                        },
                        label: function (tooltipItem, data) {
                            let total_hours = 0
                            let total_fee = 0
                            data.datasets.forEach((dataset, i) => {
                                if(dataset.raw_data[tooltipItem.index]) {
                                    total_hours += dataset.raw_data[tooltipItem.index].hours || 0
                                    total_fee += dataset.raw_data[tooltipItem.index].fee || 0
                                }
                            })
                            const raw_data = data.datasets[tooltipItem.datasetIndex].raw_data[tooltipItem.index]
                            const lines = []
                            let value = numeral(raw_data ? raw_data.hours : tooltipItem.yLabel)
                            let label = value.format("0,0.0") + "h"
                            if(total_hours) label += " / " + numeral(total_hours).format("0,0.0") + "h (" + numeral((value.value() / total_hours) * 100).format("0,0") + "%)"
                            lines.push(label)

                            if(raw_data) {
                                value = numeral(raw_data.fee)
                                label = "$ " + value.format("0,0")
                                if(total_fee) label += " / $ " + numeral(total_fee).format("0,0") + " (" + numeral((value.value() / total_fee) * 100).format("0,0") + "%)"
                                lines.push(label)
                            }

                            return lines
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            suggestedMax: this.yMax,
                            fontColor: "#00274F",
                            callback: (value, index, values) => {
                                if(this.field === "fee") {
                                    const value_numeral = numeral(value)
                                    values = value_numeral.value()
                                    if(value >= 100000) return `$ ${numeral(value / 1000000).format("0,0.0")}M`
                                    if(value >= 1000) return `$ ${numeral(value / 1000).format("0,0.0")}K`
                                    return `$ ${value_numeral.format("0,0")}`
                                }
                                return numeral(value).format("0,0") + "h"
                            }
                        },
                        gridLines: {
                            display: true,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: false,
                    position: "bottom",
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        field: {
            type: String,
            required: true
        },
        yMax: {
            type: Number,
            default: 0
        }
    }
})
